'use client';

import { useEffect, useState } from 'react';

export function useLiveClock(
  intervalMs: number,
  enabled: boolean,
  initialNowMs: number = 0,
): number {
  const [nowMs, setNowMs] = useState(initialNowMs);

  useEffect(() => {
    if (!enabled) return;
    const timer = window.setInterval(() => setNowMs(Date.now()), intervalMs);
    return (): void => window.clearInterval(timer);
  }, [enabled, intervalMs]);

  return nowMs;
}
